module.exports = __webpack_public_path__ + "assets/img/29_192_big.2e1604cc.jpg";